import { useGetPricingPackageQuery } from "~graphql/generated/graphql"

export default function usePricingPackage(id: string | null | undefined) {
    const {
        data,
        loading: isLoading,
        error,
    } = useGetPricingPackageQuery({
        variables: { id: id ?? "" },
        skip: !id,
        // Using no-cache so that this query doesn't overwrite the availability props
        // in pricingPackagesByListing and make the package become disabled in the UI.
        fetchPolicy: "no-cache",
    })

    const pricingPackage = data?.pricingPackage ?? null

    return { pricingPackage, isLoading, error }
}
